import { getStartDate } from '../selectors/getStoreProperties';
import { utcDate } from 'owa-datetime/lib/owaDate/owaDate';

/**
 * Utility function to get start date time
 * @returns start date time from store
 */
export default function getStartDateTime() {
    const startDate = getStartDate();
    return startDate ? utcDate(startDate).toISOString() : null;
}
